import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ProjectManagementLoader from '../loader/loader';
import ProjectManagementSupport from './HelpandSupport';

const HelpSupportWithLoader = () => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // Detect when navigating to the help & support page
  useEffect(() => {
    if (location.pathname === '/help&support') {
      setLoading(true);
      
      // Simulate page loading time
      const timer = setTimeout(() => {
        setLoading(false);
      }, 3000); // Show loader for 3 seconds
      
      return () => clearTimeout(timer);
    }
  }, [location]);

  return (
    <div className="min-h-screen">
      {/* The loader component */}
      <ProjectManagementLoader 
        isLoading={loading} 
        onLoadComplete={() => setLoading(false)} 
      />
      
      {/* The actual support page (only visible when loading is complete) */}
      {!loading && <ProjectManagementSupport />}
    </div>
  );
};

export default HelpSupportWithLoader;